import Api from '../helpers/api';

const institutionSettingsMap = {
  jobTitlesConfig: [52, 'requirementLevel'],
};

async function findInstitutionSettingValue(institutionSetting) {
  return Api.get(`/preset/institution-settings/${institutionSetting[0]}?format=${institutionSetting[1]}`);
}

export async function getJobTitlesConfig() {
  return findInstitutionSettingValue(institutionSettingsMap.jobTitlesConfig);
}
